import React, {useState, useRef, useEffect} from 'react';
import './UserCard.css';
import './Card.css';

export default function UserCard({app_user, show_display}) 
{
    const [img_loc] = useState('./images/'); 
    const [img_ext] = useState('.svg'); 
    const [img_sel] = useState('-sel'); 

    const [img_user]          = useState('user'); 
    const [img_create_team]   = useState('add'); 
    const [img_join_team]     = useState('request'); 
    const [img_user_history]  = useState('history'); 
    const [img_user_settings] = useState('settings'); 
    const [img_user_info]     = useState('info'); 
    
    const [img_user_file,          setImgUserFile]      = useState(img_loc + img_user          + img_sel + img_ext); 
    const [img_create_team_file,   setCreateTeamFile]   = useState(img_loc + img_create_team   + img_ext); 
    const [img_join_team_file,     setJoinTeamFile]     = useState(img_loc + img_join_team     + img_ext); 
    const [img_user_history_file,  setUserHistoryFile]  = useState(img_loc + img_user_history  + img_ext); 
    const [img_user_settings_file, setUserSettingsFile] = useState(img_loc + img_user_settings + img_ext); 
    const [img_user_info_file,     setUserInfoFile]     = useState(img_loc + img_user_info     + img_ext); 

    const [current_display_type, setCurrentDisplayType] = useState("user-lists"); 

    const tooltipRef_user          = useRef(null);
    const tooltipRef_create_team   = useRef(null);
    const tooltipRef_join_team     = useRef(null);
    const tooltipRef_user_history  = useRef(null);
    const tooltipRef_user_settings = useRef(null);
    const tooltipRef_user_info     = useRef(null);

    useEffect(() => {
        const tooltip_user          = new window.bootstrap.Tooltip(tooltipRef_user.current, { container: 'body', trigger: 'hover' });
        const tooltip_create_team   = new window.bootstrap.Tooltip(tooltipRef_create_team.current, { container: 'body', trigger: 'hover' });
        const tooltip_join_team     = new window.bootstrap.Tooltip(tooltipRef_join_team.current, { container: 'body', trigger: 'hover' });
        const tooltip_user_history  = new window.bootstrap.Tooltip(tooltipRef_user_history.current, { container: 'body', trigger: 'hover' });
        const tooltip_user_settings = new window.bootstrap.Tooltip(tooltipRef_user_settings.current, { container: 'body', trigger: 'hover' });
        const tooltip_user_info     = new window.bootstrap.Tooltip(tooltipRef_user_info.current, { container: 'body', trigger: 'hover' });
  
        return () => {
            tooltip_user.dispose();
            tooltip_create_team.dispose();
            tooltip_join_team.dispose();
            tooltip_user_history.dispose();
            tooltip_user_settings.dispose();
            tooltip_user_info.dispose();
        };
    }, []);

    const change_display = (display_type) => {
        if (display_type == current_display_type) return; //No Change

        setImgUserFile(img_loc      + img_user          + img_ext);
        setCreateTeamFile(img_loc   + img_create_team   + img_ext);
        setJoinTeamFile(img_loc     + img_join_team     + img_ext);
        setJoinTeamFile(img_loc     + img_join_team     + img_ext);
        setUserHistoryFile(img_loc  + img_user_history  + img_ext);
        setUserSettingsFile(img_loc + img_user_settings + img_ext);
        setUserInfoFile(img_loc     + img_user_info     + img_ext);

        switch (display_type)
        {
            case "user-lists":         setImgUserFile(img_loc + img_user          + img_sel + img_ext); break;
            case "create-team":     setCreateTeamFile(img_loc + img_create_team   + img_sel + img_ext); break;
            case "request-join-team": setJoinTeamFile(img_loc + img_join_team     + img_sel + img_ext); break;
            case "team_invitations":  setJoinTeamFile(img_loc + img_join_team     + img_sel + img_ext); break;
            case "user-history":   setUserHistoryFile(img_loc + img_user_history  + img_sel + img_ext); break;
            case "user-settings": setUserSettingsFile(img_loc + img_user_settings + img_sel + img_ext); break;
            case "user-information":  setUserInfoFile(img_loc + img_user_info     + img_sel + img_ext); break;
        }
        setCurrentDisplayType(display_type);
        show_display(display_type);
    } 

    var num_teams = app_user.NumTeams - 1; //remove private team
    var team_txt = (num_teams == 1 ? `${num_teams} team` : `${num_teams} teams`);
    var invite_txt = (app_user.NumTeamInvitations == 1 ? `, ${app_user.NumTeamInvitations} invitation` : `, ${app_user.NumTeamInvitations} invitations`);
    var join_request_txt = (app_user.NumUserJoinRequests == 1 ? `, ${app_user.NumUserJoinRequests} join request` : `, ${app_user.NumUserJoinRequests} join requests`);

    var invite_style_class = (app_user.NumTeamInvitations > 0 ? "card-link-highlight" : "card-link-normal");
    var join_request_style_class = (app_user.NumUserJoinRequests > 0 ? "card-link-highlight" : "card-link-normal");
   
    return (
        <>
            <div class="card text-center">
                <div id="user-card-body" class="card-body">
                    <h5 class="card-title">{app_user.UserFullName}</h5>
                    <h6 class="card-subtitle mb-2 text-body-secondary">{app_user.UserDescription}</h6>
                    <div class="row">
                        <div class="col text-start">
                            <small>
                                <span class="card-link-normal"><a href="#" onClick={ () => change_display("user-lists") }>{team_txt}</a></span>
                                <span class={invite_style_class}><a href="#" onClick={ () => change_display("team_invitations") }>{invite_txt}</a></span>
                                <span class={join_request_style_class}><a href="#" onClick={ () => change_display("team_invitations") }>{join_request_txt}</a></span>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-body-secondary text-end">
                    <a href="#" ref={tooltipRef_user}          data-bs-toggle="tooltip" data-bs-title="User List Index"  data-bs-delay="750"><img class="card-icon"     src={img_user_file}          alt="user lists"  border="0" onClick={ () => change_display("user-lists") }/></a>
                    <a href="#" ref={tooltipRef_create_team}   data-bs-toggle="tooltip" data-bs-title="Create New Team"  data-bs-delay="750"><img class="card-icon"     src={img_create_team_file}   alt="create team" border="0" onClick={ () => change_display("create-team") }/></a>
                    <a href="#" ref={tooltipRef_join_team}     data-bs-toggle="tooltip" data-bs-title="Join Team"        data-bs-delay="750"><img class="card-icon"     src={img_join_team_file}     alt="join team"   border="0" onClick={ () => change_display("request-join-team") }/></a>
                    <a href="#" ref={tooltipRef_user_history}  data-bs-toggle="tooltip" data-bs-title="User History"     data-bs-delay="750"><img class="card-icon"     src={img_user_history_file}  alt="history"     border="0" onClick={ () => change_display("user-history") }/></a>
                    <a href="#" ref={tooltipRef_user_settings} data-bs-toggle="tooltip" data-bs-title="User Settings"    data-bs-delay="750"><img class="card-icon"     src={img_user_settings_file} alt="settings"    border="0" onClick={ () => change_display("user-settings") }/></a>
                    <a href="#" ref={tooltipRef_user_info}     data-bs-toggle="tooltip" data-bs-title="User Information" data-bs-delay="750"><img class="card-icon-end" src={img_user_info_file}     alt="info"        border="0" onClick={ () => change_display("user-information") }/></a>
                </div>
            </div>
        </>
    );
}